import { render, staticRenderFns } from "./PieTDWidgetForParentOrg.vue?vue&type=template&id=359de917&scoped=true"
import script from "./PieTDWidgetForParentOrg.vue?vue&type=script&lang=js"
export * from "./PieTDWidgetForParentOrg.vue?vue&type=script&lang=js"
import style0 from "./PieTDWidgetForParentOrg.vue?vue&type=style&index=0&id=359de917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359de917",
  null
  
)

export default component.exports